$(document).ready(function()
{
    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }
});